import { Route, Routes } from "react-router-dom";
import { RegisterType } from "../../__generated__/base.gql";
import { RequestRegisterDownloadPage } from "./_lib/download-page";
import { AncRegister } from "./anc/page";
import { ChildImmunisationRegisterPage } from "./child-immunisation/page";
import { RegisterDownloadRequestsPage } from "./download-requests/page";
import { RegisterLayout } from "./layout";
import { NigeriaDailyOutpatientRegister } from "./nigeria/daily-outpatient/page";
import { NigeriaGeneralAttendanceRegister } from "./nigeria/general-attendance/page";
import { PatientRegisterDownload } from "./patient/download/page";
import { PatientRegister } from "./patient/page";

export const RegistersRoutes = () => (
  <Routes>
    <Route element={<RegisterLayout />}>
      <Route path="patient">
        <Route index element={<PatientRegister />} />
        <Route path="download" element={<PatientRegisterDownload />} />
      </Route>
      <Route path="anc">
        <Route index element={<AncRegister />} />
        <Route
          path="download"
          element={
            <RequestRegisterDownloadPage registerType={RegisterType.Anc} />
          }
        />
      </Route>
      <Route path="nigeria">
        <Route path="daily-outpatient">
          <Route index element={<NigeriaDailyOutpatientRegister />} />
          <Route
            path="download"
            element={
              <RequestRegisterDownloadPage
                registerType={RegisterType.NigeriaDailyOutpatient}
              />
            }
          />
        </Route>
        <Route
          path="general-attendance"
          element={<NigeriaGeneralAttendanceRegister />}
        >
          <Route index element={<NigeriaGeneralAttendanceRegister />} />
          <Route
            path="download"
            element={
              <RequestRegisterDownloadPage
                registerType={RegisterType.NigeriaGeneralAttendance}
              />
            }
          />
        </Route>
      </Route>
      <Route
        path="download-requests"
        element={<RegisterDownloadRequestsPage />}
      />
      <Route
        path="child-immunisation"
        element={<ChildImmunisationRegisterPage />}
      />
    </Route>
  </Routes>
);
